import React, { useState } from "react";
import { removeNumber } from "../../functions/office/officeTwilioNumber";
import { useNavigate } from "react-router";

const DeactivateTwilioModal = ({ setDeactivateModal, officeId }) => {
  const navigate = useNavigate();

  const [message, setMessage] = useState(
    "Are you sure you want to deactivate Twilio for this office?"
  );
  const [showConfirmBtn, setShowConfirmBtn] = useState(true);

  const handleClose = () => {
    navigate(`/viewOfficeInfo`);
    setDeactivateModal(false);
  };

  const confirmed = async () => {
    const result = await removeNumber(officeId);

    if (result.result !== 0) {
      setMessage("Error: Failed to deactivate Twilio for this office.");
      setShowConfirmBtn(false);
    } else {
      setMessage(`Success: Twilio deactivated.`);
      setShowConfirmBtn(false);
    }
  };

  return (
    <>
      <div className="modal-overlay" onClick={() => handleClose()} />
      <div className="modal-wrapper">
        <div className="modal">
          <div className="modal-header">
            <h5 className="modal-heading">Confirmation</h5>
          </div>
          <div className="modal-message">{message}</div>
          <div className="modal-btns">
            {showConfirmBtn && (
              <button className="modal-confirm-btn" onClick={() => confirmed()}>
                Confirm
              </button>
            )}
            <button className="modal-cancel-btn" onClick={() => handleClose()}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeactivateTwilioModal;
